<div class="options-display">
  <div *ngFor="let op of optionsListDetails?.answerOptionItem">
    <div class="custom-checkbox" [ngClass]="{'pointer':!isDisableSignal$()}" (click)="isDisableSignal$()?null:chooseOption(op.guid)">
      <div class="choose" 
        [ngClass]="{'selected': isExist(op.guid) == true}">
        <div class="inner-selected">
          <img src="/assets/images/auto-fill/vi.svg">
        </div>
      </div>
      <div >
        <p *ngIf="op.name!=''" class="text">{{op.name}}</p>
        <p *ngIf="op.name==''" translate class="text">questionBoard.edit.noValue</p>
      </div>
    </div>
  </div>
</div>